import values from 'lodash/values';
import has from 'lodash/has';
import get from 'lodash/get';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import isEqual from 'lodash/isEqual';
import {
    getModels,
    getSearchModels,
    getSearchTerm, getSettings
} from "~/stateGetter";
import {haveSearchModelsErrored, presentSearchResultParams} from "~/statePresenter";
import {fetchSearchResults} from "~/rx/search";
import identify from "~/identify";
import limit from "~/data/limit";
import cancelToken from "~/data/cancelToken";

const SYNC_STATUS = {
    OK: 'ok',
    SYNC: 'sync',
    CANCEL: 'cancel',
};

export class SearchResultsManager extends Component {
	static propTypes = {

	};

    updateResults(modelNames) {
        let { fetchSearchResults } = this.props;
        let requestGroup = identify.searchRequestGroup('all'),
            cancelTokens = {};

        modelNames.forEach((name) => {
            cancelTokens[name] = cancelToken(identify.searchRequestGroup(name));
        });

        limit(requestGroup, () => {
            fetchSearchResults(modelNames, cancelTokens);
        }, 250);
    }

    keepInSync = () => {
          let allParams = this.props.allParams,
              syncModelNames = [];

          if(this.props.hasError) { return; }
          if(this.props.searchTerm.length < 1) { return; }


          for(let params of allParams) {

              let status = this.getStatus(params);

              switch(status) {
                  case SYNC_STATUS.SYNC:
                      syncModelNames.push(params.modelName);
                      break;
                  case SYNC_STATUS.CANCEL:
                      cancelToken(identify.searchRequestGroup(params.modelName)).cancel();
                      break;
              }
          }

          if(!syncModelNames.length) {
            return;
          }

          this.updateResults(syncModelNames);
    };

    getStatus(props) {
        let { loadedResultParams, loadingResultParams, params, resultState } = props;

        if(resultState.status === identify.STATUS_ERRORED) { return SYNC_STATUS.OK; }
        if(resultState.status === identify.STATUS_INVALIDATED) { return SYNC_STATUS.SYNC; }

        let areLoadedResultParamsEqual = isEqual(params, loadedResultParams);

        let shouldDoSync = !isEqual(params, loadingResultParams) &&
            !areLoadedResultParamsEqual;

        if(shouldDoSync) {
            return SYNC_STATUS.SYNC;
        } else if(areLoadedResultParamsEqual) {
            return SYNC_STATUS.CANCEL;
        }
	}

    componentDidMount() {
       this.keepInSync();
    }

    componentDidUpdate(prevProps) {
        this.keepInSync();
    }

	render() {
		return null;
	}
}

const presentAllParams = (searchModels, models, searchTerm, settings) => {
    return values(searchModels).map((searchModel) => {
        let resultState = searchModel.results,
            modelName = searchModel.modelName;

        let searchFilter = models[modelName].dataModel.searchFilter,
            searchSort = searchModel.resultParams.sortOptions;

        return {
            resultState,
            modelName,
            params: presentSearchResultParams({searchModel, searchFilter, searchTerm, searchSort}),
            loadedResultParams: resultState.loadedParams,
            loadingResultParams: resultState.loadingParams,
        }
    });
};

const RXSearchResultsLoader = connect(
    (state) =>  {
        return {
			searchTerm: getSearchTerm(state),
			searchModels: getSearchModels(state),
            models: getModels(state),
            settings: getSettings(state)
        }
    },
    (dispatch, {modelName}) => ({
        fetchSearchResults: (modelName, cancel) => dispatch(fetchSearchResults(modelName, cancel))
    }),
	({searchModels, models, searchTerm, settings, ...props}, dispatchers, ownProps) => {

        let hasError = haveSearchModelsErrored(searchModels);

        return {
            hasError,
            ...ownProps, ...props, ...dispatchers, searchTerm,
        	allParams: presentAllParams(searchModels, models, searchTerm, settings)
		}
	}
)(SearchResultsManager);

export default RXSearchResultsLoader;